import jszip from 'jszip';

const ALLOWED_EXTENSIONS = ['doc', 'docx', 'jpg', 'png', 'pdf', 'tif', 'tiff'];
const MAX_FILE_SIZE_MB = 20;

export const checkFileSize = (file: File): boolean => {
  if (file.size < 1024) return false;
  const MB = file.size / 1024 / 1024;
  return MB <= MAX_FILE_SIZE_MB;
};

export const checkExtension = (file: File): boolean => {
  const fileExt = file.name.split('.').pop()?.toLowerCase();
  return !!fileExt && ALLOWED_EXTENSIONS.includes(fileExt);
};

export const isFileValid = async (file: File): Promise<boolean> => {
  const fileExt = file.name.split('.').pop()?.toLowerCase();

  if (fileExt === 'pdf') {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = async function () {
        const files = new Blob([file], { type: 'application/pdf' });
        const text = await files.text();
        const isEncrypted =
          text.includes('Encrypt') ||
          text
            .substring(text.lastIndexOf('<<'), text.lastIndexOf('>>'))
            .includes('/Encrypt');
        resolve(!isEncrypted);
      };
      reader.onerror = () => resolve(false);
    });
  }

  if (fileExt === 'doc' || fileExt === 'docx') {
    try {
      const zip = await jszip.loadAsync(file);
      const hasMacros = Object.keys(zip.files).some((f) =>
        f.includes('vbaProject')
      );
      return !hasMacros;
    } catch {
      return false;
    }
  }

  return true;
};

export const validateFile = async (file: File): Promise<boolean> => {
  const cleanName = file.name.trim();
  const nameWithoutExtension = cleanName.split('.').slice(0, -1).join('.');
  const fileExt = cleanName.split('.').pop();

  const isInvalid =
    !file ||
    file.size < 1024 ||
    !cleanName ||
    !fileExt ||
    !nameWithoutExtension ||
    !checkFileSize(file) ||
    !checkExtension(file) ||
    !(await isFileValid(file));

  return !isInvalid;
};
